module.exports = __webpack_public_path__ + "img/recorte-ticket.3cee734d.png";